import { COMMON } from 'Constants/ActionTypes'; // 引入action类型常量名

const { TOGGLE_SIDER, GET_TASK_PROGRESS, GET_SIDE_NAV, SET_SPA } = COMMON;

// 初始化state数据
const initialState = {
  collapsed: true,
  taskProgress: { all: 0, finish: 0 },
  menuList: [],
  spa: false
};

// 通过dispatch action进入
// 根据不同的action type进行state的更新
export default function common(state = initialState, action) {
  switch (action.type) {
    case `${TOGGLE_SIDER}`:
      return {
        ...state,
        collapsed: action.data,
      };
    case `${GET_TASK_PROGRESS}_SUCCESS`:
      return {
        ...state,
        taskProgress: {
          all: (action.payload.data && action.payload.data.all) || 0,
          finish: (action.payload.data && action.payload.data.finish) || 0,
        },
      };
    case `${SET_SPA}`:
      return {
        ...state,
        spa: action.data,
      };
    case `${GET_SIDE_NAV}_SUCCESS`:
      //手动添加音色市场
      let menuList_new = [];
      if (action.payload.data && action.payload.data.length !== 0 && action.payload.data[2].children) {
        action.payload.data[2].children.map(item => {
          if (item.name == '系统设置') {
            let obj = {
              children: null,
              code: "systemSettingSoundMarket",
              component: "./containers/systemSetting/soundMarket",
              iconName: null,
              name: "音色市场",
              path: "/soundMarket",
              redirect: null,
              to: "/systemSetting/soundMarket"
            }
            if (item.children) {
              item.children.push(obj);
            } else {
              item.children = [];
              item.children.push(obj);
            }
          }
        })
      }
      return {
        ...state,
        menuList: action.payload.data && action.payload.data.length !== 0 ? action.payload.data[2].children : null,
      };
    default:
      return state;
  }
}
